import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import type { MobileAppBannerType } from "@/features/static-builder/types/mobile-app-banner.type";
import {
  fetchStrapiFromClient,
  type StrapiClientResponse,
} from "@/services/strapi-client";
import { MobileAppDataType } from "@/types/mobile-app-data.type";

const MOBILE_APP_DATA_ENDPOINT = "/app-info";

const useMobileAppData = (
  options?: Omit<
    UseQueryOptions<
      StrapiClientResponse<MobileAppDataType>,
      unknown,
      StrapiClientResponse<MobileAppDataType>,
      string[]
    >,
    "queryFn" | "queryKey"
  >
) => {
  return useQuery({
    queryKey: ["panel-app-banner"],
    queryFn: async (): Promise<StrapiClientResponse<MobileAppDataType>> => {
      const result = await fetchStrapiFromClient<MobileAppDataType>(
        MOBILE_APP_DATA_ENDPOINT
      );
      return result;
    },
    ...options,
  });
};

export { useMobileAppData };
